import { render } from "./musicBar.vue?vue&type=template&id=c51afc8e&scoped=true"
import script from "./musicBar.vue?vue&type=script&lang=js"
export * from "./musicBar.vue?vue&type=script&lang=js"

import "./musicBar.vue?vue&type=style&index=0&id=c51afc8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c51afc8e"]])

export default __exports__